<template>
  <div>
    <v-row v-if="false">
      <v-col md="6">
        <v-card
            dark
            color="deep-purple accent-2"
        >
          <v-card-title>16.543 locais</v-card-title>
          <v-card-text>
            <p>1511 Não confirmados</p>
            <p>5 Suspensos</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="6">
        <v-card>
          <v-card-title>Avaliações</v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
